import DataStore from './DataStore';
import Utils from '../common/Utils';
import BasicInfo from './components/Basicinfo';
import Listinfo from "./components/Listinfo";
import AbilityInfo from "./components/Abilityinfo";
import ItemInfo from "./components/Iteminfo";
import SoulshieldInfo from "./components/Soulshieldinfo";
import EffectInfo from "./components/Effectinfo";
import IScrollTab from "../common/components/IScrollTab";
import ProfileImg from "./components/ProfileImg";

/**
 * character의 시작점
 * @category character
 * @memberof module:character
 * @param  {Object} _config={} 설정 옵션
 */
class App {
    constructor(_config = {}) {
        this.tabMenu = null;
        this.store = new DataStore(_config);
        this.selector = '#container';
        this.init(this.store);

        if(_config.isValidCharacter){
            this.basicinfo = new BasicInfo(this.store, this.selector + ' .character-info-header', ()=>{
                this.listinfo = new Listinfo(this.store, this.selector + ' .character-list');
              this.profileimg = new ProfileImg(this.store);
            });

            if(window.location.href.includes('/character') && (!window.location.href.includes('/myboard')) && (!window.location.href.includes('/mycomment')) && (!window.location.href.includes('/bookmark')) && (!window.location.href.includes('/chatlog'))){
                this.abilityinfo = new AbilityInfo(this.store, this.selector + ' .character-ability-inner');
                this.effectinfo = new EffectInfo(this.store, this.selector + ' .character-effect');
                this.iteminfo = new ItemInfo(this.store, this.selector + ' .character-item');
                this.soulshieldinfo = new SoulshieldInfo(this.store, this.selector + ' .character-soulshield-inner');
                this.store.getCharacterItemData(this.store.data.config.serverType, this.store.data.config.serverId, this.store.data.config.characterName, (_jsonData)=>{
                  this.iteminfo.render(_jsonData);
                  this.soulshieldinfo.render(_jsonData);
                });
              //this.iteminfo = new ItemInfo(this.store, this.selector + ' .character-item');
              //this.soulshieldinfo = new SoulshieldInfo(this.store, this.selector + ' .character-soulshield-inner');
            }
        }

        this.addEvents(this.store);
        if (window.ncui && window.ncui.autoSuggest) {
          new ncui.autoSuggest({
            apiUrl: 'https://api-search.plaync.com/bns/search/v2/character/suggest',
            addParam: {}, // api 에 추가로 붙여서 보낼 파람이 있을경우
            selector : '#bnsAutoSuggest', // 검색 form이 삽입될 컨테이너 selector
            size: 10, // 자동완성 리스트 갯수
            useDelbtn: true, // 검색어 삭제 버튼 활성화
            useRecent: true, // 최근검색어 목록 사용 여부
            cookieName: 'autosuggest', // 최근검색어가 저장될 쿠키의 키네임
            keywordParamName: 'keyword',
            placeholderStr: '캐릭터명을 입력해주세요.',
            useCookie: true, // 쿠키를 사용해도 되는지여부 (1.7.20 추가)
            submitCallback: (_q) => {
              let property = '/world/charactersearch#'+_q;
              location.href = property;
             }
          });
        }

        // let autoSuggest = new AutoSuggest();
        // autoSuggest.init({
        //     selector : '#autoSuggest',
        //     service: 'bns',
        //     alias: 'character',
        //     size: 10,
        //     useDelbtn: true,
        //     apiUrl: 'https://searchsuggest.plaync.com/suggest/bns/v1.0/character',
        //     submitCallback: function(_q){
        //     }
        // });
    }

    init(_d) {
        $(document).ready(function() {
            $(".wrap-contents .loading-wrap").removeClass('is-show');
            $('.wrap-contents').addClass('character');
        });
        if(window.location.href.includes('/charactersearch')) return;
        if(_d.data.config.isValidCharacter){
            let tabSelectIds =[], selectId = '';
            document.querySelectorAll('#tabMenu .ui-tab-item').forEach(ele=>{
                tabSelectIds.push(ele.dataset.value);
            });
            selectId = window.location.pathname.split('/').pop();
            if(tabSelectIds.indexOf(selectId) < 0)selectId = 'character';
            this.tabMenu = new IScrollTab({
                id:selectId
            },  document.querySelector('#tabMenu'));
        }
    }

    addEvents(_d){
        // $(document).on('click', '.section-searchform-inner [data-name=suggest_submit]', (e)=>{
        //     let inputText = encodeURI($('.section-searchform-inner [data-name=suggest_input]')[0].value);
        //     let property = '/world/charactersearch#'+inputText;
        //     location.href = property;
        // });
        //
        // $('[data-name=suggest_input]').on('keydown', (e)=>{
        //
        //     if (e.which === 13) {
        //         let inputText = encodeURI($('.section-searchform-inner [data-name=suggest_input]')[0].value);
        //         let property = '/world/charactersearch#'+inputText;
        //         location.href = property;
        //     }
        // });

        $(document).on('click', '.character-info-header .btn-gift', (e)=>{
           // window.ncrwd.ncoin.open(serverTypeValue, _d.data.config.serverId, _d.data.config.characterName);
            window.ncoinGiftPopup.open( _d.data.config.serverId, _d.data.config.characterName);
        });

        $(document).on('click', '.character-dimmed-layer.is-dimmed', (e)=>{
            if($('.ability-header-layer').hasClass('is-show')){
                $('.ability-header-layer').removeClass('is-show');
                $('.character-dimmed-layer').removeClass('is-dimmed');
            }
            else if($('.character-list-layer').hasClass('is-show')){
                $('.character-list-layer').removeClass('is-show');
                $('.character-dimmed-layer').removeClass('is-dimmed');
            }
        });
    }
}

Utils.namespace('nc.bns.character');
nc.bns.character = App;

